"use client";

import Script from "next/script";

const RB2B = () => {
    return (
        <Script
            id="rb2b"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
          !function(key) {
            if (window.reb2b) return;
            window.reb2b = {loaded: true};
            var s = document.createElement("script");
            s.async = true;
            s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";
            document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);
          }("${process.env.NEXT_PUBLIC_RB2B}");
        `,
            }}
        />
    );
};

export default RB2B;
